import { useState, useEffect, useCallback } from 'react';
import translations from './translations';

const STORAGE_KEY = 'maestro_language';
const EVENT_NAME = 'maestro-language-change';

export function useTranslation() {
  const [lang, setLang] = useState(() => localStorage.getItem(STORAGE_KEY) || 'en');

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === STORAGE_KEY) setLang(e.newValue || 'en');
    };
    const onCustom = (e) => setLang(e.detail || 'en');
    window.addEventListener('storage', onStorage);
    window.addEventListener(EVENT_NAME, onCustom);
    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener(EVENT_NAME, onCustom);
    };
  }, []);

  const t = useCallback((key, vars) => {
    let str = translations[lang]?.[key] || translations.en[key] || key;
    if (vars) {
      Object.entries(vars).forEach(([k, v]) => {
        try {
          str = str.replace(new RegExp(`\\{${k}\\}`, 'g'), v);
        } catch {
          str = str.split(`{${k}}`).join(v);
        }
      });
    }
    return str;
  }, [lang]);

  const setLanguage = useCallback((code) => {
    localStorage.setItem(STORAGE_KEY, code);
    setLang(code);
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: code }));
  }, []);

  return { t, lang, setLanguage };
}
